// the following article types has no categories page
export const NO_CATEGORY_TYPES = [
  "Glossary Term",
  "glossary",
  "Market Update",
  "Global Logistics Update",
  "case-study",
];

export const SHORT_MONTHS = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];
